export default __webpack_public_path__ + "static/media/african-opulent-holdings-image.f343fea7.jpg";